import { render, staticRenderFns } from "./ConstructionPeriodsEditor.vue?vue&type=template&id=5284fa26&scoped=true"
import script from "./ConstructionPeriodsEditor.vue?vue&type=script&lang=js"
export * from "./ConstructionPeriodsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284fa26",
  null
  
)

export default component.exports